var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenBackgroundSolidWhiteTick = function SvgGreenBackgroundSolidWhiteTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#0EA546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45472 4.76446C9.80822 4.41152 10.3814 4.41152 10.7349 4.76446C11.0884 5.11743 11.0884 5.68968 10.7349 6.04262L7.03665 9.73505C6.68313 10.088 6.10999 10.088 5.75649 9.73505L3.76512 7.74681C3.41163 7.39387 3.41163 6.82162 3.76512 6.46868C4.11864 6.11573 4.69178 6.11573 5.04528 6.46868L6.39656 7.81783L9.45472 4.76446Z",
    fill: "white"
  })));
};
export default SvgGreenBackgroundSolidWhiteTick;